import { render, staticRenderFns } from "./CollegeAdminDashboard.vue?vue&type=template&id=77b4493e&"
import script from "./CollegeAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./CollegeAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CollegeAdminDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports